import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";

import {
  Button,
  Divider,
  Typography,
  Grid,
  CircularProgress,
  Checkbox,
  Box,
  MenuItem,
  ListItemText,
  Chip,
  TextField,
  FormControlLabel,
} from "@mui/material";

import { useReactToPrint } from "react-to-print";
import { useSnackbar } from "notistack";

import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import {
  LocalizationProvider,
  DatePicker,
  DateTimePicker,
} from "@mui/x-date-pickers";

import CharterReport from "../components/reports/CharterReport";
import ExternalReport from "../components/reports/ExternalReport";
import DailyReport from "../components/reports/DailyReport";
import OccupancyReport from "../components/reports/OccupancyReport";

import Logo from "@assets/images/logo_3.png";

import { apiGet } from "@services/API";
import moment from "moment";

import { CSVLink } from "react-csv";

moment.updateLocale("en", {
  week: {
    dow: 1,
  },
});

function headers() {
  let headers = {};
  let token = localStorage.getItem("covid19_token");
  let mfa_token = localStorage.getItem("mfa_token");
  if (token && token.length > 0 && mfa_token && mfa_token.length > 0) {
    headers = { "x-access-token": token };
  }
  return headers;
}

export default function Reports({ ...props }) {
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  let qType = queryParams.get("type");
  let qHospitalID = queryParams.get("hospitalID");
  let qWardID = queryParams.get("wardID");

  const level = parseInt(localStorage.getItem("user_level"), 10);
  const hospitalID = localStorage.getItem("hospital_id");

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [dataFiltered, setDataFiltered] = useState([]);

  const [fromDate, setFromDate] = useState(
    qType !== undefined && qType !== null ? moment().startOf("day") : null
  );
  const [toDate, setToDate] = useState(
    qType !== undefined && qType !== null ? moment().endOf("day") : null
  );

  const [date, setDate] = useState(
    qType !== undefined && qType !== null ? moment().startOf("day") : null
  );

  const [dataHospitals, setDataHospitals] = useState([]);

  const [selectedReportType, setSelectedReportType] = useState(
    qType !== undefined && qType !== null ? qType : ""
  );
  const [selectedHospitals, setSelectedHospitals] = useState([]);

  const [dataHospitalsOfOrigins, setDataHospitalsOfOrigins] = useState([]);
  const [selectedHospitalsOfOrigins, setSelectedHospitalsOfOrigins] = useState([
    1,
  ]);

  const [dataWards, setDataWards] = useState([]);
  const [selectedWards, setSelectedWards] = useState([]);

  const [isNEWSSelected, setIsNEWSSelected] = useState(true);
  const [isWaterlowSelected, setIsWaterlowSelected] = useState(true);
  const [isMMSESelected, setIsMMSESelected] = useState(true);
  const [isFrailtySelected, setIsFrailtySelected] = useState(true);
  const [isBarthelSelected, setIsBarthelSelected] = useState(true);
  const [isMUSTSelected, setIsMUSTSelected] = useState(true);
  const [isNotesSelected, setIsNotesSelected] = useState(true);
  const [isPlansSelected, setIsPlansSelected] = useState(true);

  const [dataRoles, setDataRoles] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);

  const componentRef = useRef();

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchHospitalsOfOriginTypes();
    fetchHospitals();
    fetchRoles();
  }, []);

  useEffect(() => {
    if (!isNullOrEmpty(qWardID) && dataWards.length > 0) {
      setSelectedWards([Number(qWardID)]);
    }
  }, [dataWards]);

  useEffect(() => {
    if (!isNullOrEmpty(qWardID) && selectedHospitals.length > 0) {
      setDataWards([]);
      selectedHospitals.forEach((hospitalId) => {
        fetchWardsForHospital(Number(hospitalId));
      });
    }
  }, [selectedHospitals]);

  useEffect(() => {
    if (!isNullOrEmpty(qHospitalID) && dataHospitals.length > 0) {
      setSelectedHospitals([Number(qHospitalID)]);
    }
  }, [dataHospitals]);

  useEffect(() => {
    const filteredData = data.map((patient) => {
      const notes =
        patient.notes && patient.notes.length > 0 && patient.notes.trim()
          ? JSON.parse(patient.notes)
          : [];

      const plans =
        patient.plans && patient.plans.length > 0 && patient.plans.trim()
          ? JSON.parse(patient.plans)
          : [];

      //Filter notes
      const filteredNotes = notes.filter((note) =>
        selectedRoles.includes(Number(note.level))
      );

      // Filter plans
      const filteredPlans = plans.filter((plan) =>
        selectedRoles.includes(Number(plan.level))
      );

      return {
        ...patient,
        notes: JSON.stringify(filteredNotes),
        plans: JSON.stringify(filteredPlans),
      };
    });

    setDataFiltered(filteredData);
  }, [selectedRoles]);

  const processData = (data) => {
    const notesReadabilityFormat = (notesArray) => {
      return notesArray
        .map((note) => {
          const noteEntry = `${note.title} by ${note.author} on ${note.note_timestamp}: ${note.log}`;
          // Check if note entry exceeds 250 characters and split it
          return noteEntry.length > 100 ? splitNoteEntry(noteEntry) : noteEntry;
        })
        .join("; ");
    };

    const splitNoteEntry = (noteEntry, maxLength = 100) => {
      let result = "";
      for (let start = 0; start < noteEntry.length; start += maxLength) {
        const end = start + maxLength;
        result +=
          noteEntry.slice(start, end) + (end < noteEntry.length ? "\n" : "");
      }
      return result;
    };
    const newData = data.map((item) => {
      const newItem = { ...item };

      if (newItem.dob) {
        try {
          newItem.dob = moment(newItem.dob).format("DD/MM/YYYY");
        } catch (error) {
          console.error("Error parsing dob:", error);
          newItem.notes = "Error parsing date dob";
        }
      }
      if (newItem.latest_weight_timestamp) {
        try {
          newItem.latest_weight_timestamp = moment(
            newItem.latest_weight_timestamp
          ).format("DD/MM/YYYY HH:MM:ss");
        } catch (error) {
          console.error("Error parsing latest_weight_timestamp:", error);
          newItem.notes = "Error parsing date latest_weight_timestamp";
        }
      }
      if (newItem.latest_news_score_timestamp) {
        try {
          newItem.latest_news_score_timestamp = moment(
            newItem.latest_news_score_timestamp
          ).format("DD/MM/YYYY HH:MM:ss");
        } catch (error) {
          console.error("Error parsing latest_news_score_timestamp:", error);
          newItem.notes = "Error parsing date latest_news_score_timestamp";
        }
      }

      if (newItem.notes) {
        try {
          const notesArray = JSON.parse(newItem.notes);
          newItem.notes = notesReadabilityFormat(notesArray);
        } catch (error) {
          console.error("Error parsing notes:", error);
          newItem.notes = "Error parsing notes";
        }
      }
      if (newItem.plans) {
        try {
          const plansArray = JSON.parse(newItem.plans);
          newItem.plans = notesReadabilityFormat(plansArray);
        } catch (error) {
          console.error("Error parsing plans:", error);
          newItem.notes = "Error parsing plans";
        }
      }

      const { patient_id, facility_id, hospital_of_origin_id, notes, ...rest } =
        newItem;
      return {
        ...rest,
        notes,
      };
    });
    return newData;
  };

  const fetchHospitals = () => {
    const timeOut = setTimeout(() => {
      apiGet(`/hospitals`, { headers: headers() }, history)
        .then((response) => {
          if (level === 1 || level === 2 || level === 3) {
            if (response.data.length > 0) {
              setDataHospitals(response.data);
            } else {
              setDataHospitals([]);
            }
          } else if (level === 5 || level === 6) {
            if (response.data.length > 0) {
              const filteredData = response.data.filter(
                (item) => Number(item.id) === Number(hospitalID)
              );
              setDataHospitals(filteredData);
            } else {
              setDataHospitals([]);
            }
          } else {
            setDataHospitals([]);
          }
        })
        .catch((error) => {
          setDataHospitals([]);
        });
    }, 200);

    return () => clearTimeout(timeOut);
  };
  // const groupByHospitalOfOrigin = (patients) => {
  //   const calculateStayLength = (admittedDate, dischargeDate) => {
  //     const admitted = new Date(admittedDate);
  //     const discharge = dischargeDate ? new Date(dischargeDate) : new Date();
  //     const timeDiff = discharge - admitted;
  //     return Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  //   };

  //   const groups = patients.reduce((acc, patient) => {
  //     const key = patient.hospital_of_origin_id || "unknown";

  //     if (!acc[key]) {
  //       acc[key] = {
  //         hospital_of_origin_name:
  //           patient.hospital_of_origin_name || "Unknown Hospital",
  //         patients: [],
  //       };
  //     }
  //     const filteredPatient = {
  //       mrn: patient.mrn,
  //       firstname: patient.firstname,
  //       surname: patient.surname,
  //       dob: patient.dob,
  //       gender: patient.gender,
  //       admitted_date: patient.admitted_date
  //         ? moment(patient.admitted_date).format("DD/MM/YYYY HH:MM:ss")
  //         : "",
  //       exptected_discharge_date: patient.exptected_discharge_date
  //         ? moment(patient.exptected_discharge_date).format(
  //             "DD/MM/YYYY HH:MM:ss"
  //           )
  //         : "",
  //       discharge_date: patient.discharge_date
  //         ? moment(patient.discharge_date).format("DD/MM/YYYY HH:MM:ss")
  //         : "",
  //       stay_length: calculateStayLength(
  //         patient.admitted_date,
  //         patient.discharge_date
  //       ),
  //     };
  //     acc[key].patients.push(filteredPatient);
  //     return acc;
  //   }, {});

  //   const sortedArray = Object.keys(groups).map((key) => ({
  //     hospital_of_origin_id: key,
  //     hospital_of_origin_name: groups[key].hospital_of_origin_name,
  //     patients: groups[key].patients,
  //   }));

  //   sortedArray.sort((a, b) =>
  //     a.hospital_of_origin_name.localeCompare(b.hospital_of_origin_name)
  //   );

  //   return sortedArray.reduce(
  //     (acc, group) => [
  //       ...acc,
  //       {
  //         hospital_of_origin_name: group.hospital_of_origin_name,
  //       },
  //       ...group.patients,
  //     ],
  //     []
  //   );
  // };

  const groupByHospitalOfOrigin = (patients) => {
    const calculateStayLength = (admittedDate, dischargeDate) => {
      const admitted = new Date(admittedDate);
      const discharge = dischargeDate ? new Date(dischargeDate) : new Date();
      const timeDiff = discharge - admitted;
      return Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    };

    const groups = patients.reduce((acc, patient) => {
      const key = patient.hospital_of_origin_id || "unknown";

      if (!acc[key]) {
        acc[key] = {
          hospital_of_origin_name:
            patient.hospital_of_origin_name || "Unknown Hospital",
          patients: [],
        };
      }
      const filteredPatient = {
        hospital_of_origin_name: acc[key].hospital_of_origin_name,
        mrn: patient.mrn,
        firstname: patient.firstname,
        surname: patient.surname,
        dob: patient.dob,
        gender: patient.gender,
        admitted_date: patient.admitted_date
          ? moment(patient.admitted_date).format("DD/MM/YYYY HH:MM:ss")
          : "",
        exptected_discharge_date: patient.exptected_discharge_date
          ? moment(patient.exptected_discharge_date).format(
              "DD/MM/YYYY HH:MM:ss"
            )
          : "",
        discharge_date: patient.discharge_date
          ? moment(patient.discharge_date).format("DD/MM/YYYY HH:MM:ss")
          : "",
        stay_length: calculateStayLength(
          patient.admitted_date,
          patient.discharge_date
        ),
      };
      acc[key].patients.push(filteredPatient);
      return acc;
    }, {});

    // Flatten groups into a single array
    return Object.values(groups).reduce((acc, group) => {
      return acc.concat(group.patients);
    }, []);
  };

  const ExportCSVButton = ({ selectedHospitals, data }) => {
    if (selectedReportType === "Occupancy") {
      const extractedData = data ? data[0].patients : [];
      console.log("ExportCSVButton Occupancy extractedData : ", extractedData);
      const groupedData = extractedData
        ? groupByHospitalOfOrigin(extractedData)
        : [];
      console.log("ExportCSVButton Occupancy groupedData : ", groupedData);

      const generateCSVHeaders = (data) => {
        const examplePatient = data.find((item) => item.mrn);

        if (!examplePatient) {
          return [];
        }

        return Object.keys(examplePatient).map((key) => {
          return {
            label: key
              .replace(/_/g, " ")
              .replace(/\b\w/g, (l) => l.toUpperCase()),
            key: key,
          };
        });
      };
      const export_headers = generateCSVHeaders(groupedData);

      const csvLinkRef = useRef();
      let exportFileName = "occupany_report.csv";
      return (
        <>
          <Button
            data-test={"reports-export-btn"}
            variant="contained"
            color="primary"
            style={{ marginRight: 10 }}
            disabled={selectedHospitals.length === 0 && data.length === 0}
            onClick={() => {
              console.log("exportting to data : ", groupedData);
              csvLinkRef.current.link.click();
            }}
          >
            Export
          </Button>
          <CSVLink
            data={groupedData}
            headers={export_headers}
            filename={exportFileName}
            ref={csvLinkRef}
            style={{ display: "none" }}
          >
            Export
          </CSVLink>
        </>
      );
    } else if (selectedReportType === "Daily") {
      const csvLinkRef = useRef();
      const exportFileName = `daily_report_export_from-${moment(
        fromDate,
        "YYYY-MM-DD HH:mm"
      )}_to-${moment(toDate, "YYYY-MM-DD HH:mm")}.csv`;

      data.sort((a, b) => a.hospital_of_origin_id - b.hospital_of_origin_id);
      const processedData = processData(data);

      const export_headers = Object.keys(processedData[0]).map((key) => {
        return {
          label: key
            .replace(/_/g, " ")
            .replace(/\b\w/g, (l) => l.toUpperCase()),
          key: key,
        };
      });

      console.log("exportting to : ", exportFileName);
      return (
        <>
          <Button
            data-test={"reports-export-btn"}
            variant="contained"
            color="primary"
            style={{ marginRight: 10 }}
            disabled={selectedHospitals.length === 0 && data.length === 0}
            onClick={() => {
              console.log("exportting to data : ", data);
              csvLinkRef.current.link.click();
            }}
          >
            Export
          </Button>
          <CSVLink
            data={processedData}
            headers={export_headers}
            filename={exportFileName}
            ref={csvLinkRef}
            style={{ display: "none" }}
          >
            Export
          </CSVLink>
        </>
      );
    } else {
      return <> </>;
    }
  };

  const fetchHospitalsOfOriginTypes = () => {
    const timeOut = setTimeout(() => {
      apiGet(`/hospitals-of-origin`, { headers: headers() }, history)
        .then((response) => {
          setDataHospitalsOfOrigins(response.data);
        })
        .catch((error) => {
          setDataHospitalsOfOrigins([]);
        });
    }, 50);

    return () => clearTimeout(timeOut);
  };

  const fetchRoles = () => {
    const timeOut = setTimeout(() => {
      apiGet(`/accessLevels`, { headers: headers() }, history)
        .then((response) => {
          setDataRoles(response.data.accessLevels);
          setSelectedRoles(
            response.data.accessLevels.map((role) => role.level_id)
          );
        })
        .catch((error) => {
          setDataRoles([]);
        });
    }, 50);

    return () => clearTimeout(timeOut);
  };

  const resetDailyReportFilters = () => {
    setIsNEWSSelected(true);
    setIsWaterlowSelected(true);
    setIsMMSESelected(true);
    setIsFrailtySelected(true);
    setIsBarthelSelected(true);
    setIsMUSTSelected(true);
    setIsNotesSelected(true);
    setIsPlansSelected(true);
    setSelectedRoles(dataRoles.map((role) => role.level_id));
  };

  // const fetchWards = (id) => {

  //   const timeOut = setTimeout(() => {
  //     apiGet(`/facilities/` + id, { headers: headers() }, history)
  //       .then((response) => {

  //         if (!isNullOrEmpty(response.data.facilities)) {
  //           setDataWards(response.data.facilities);
  //         } else {
  //           setDataWards([]);
  //         }
  //       })
  //       .catch((error) => {
  //         setDataWards([]);
  //       });
  //   }, 200);

  //   return () => clearTimeout(timeOut);
  // };

  const fetchWardsForHospital = async (hospitalId) => {
    try {
      const response = await apiGet(
        `/facilities/${hospitalId}`,
        { headers: headers() },
        history
      );
      if (!isNullOrEmpty(response.data.facilities)) {
        setDataWards((prevData) => [...prevData, ...response.data.facilities]);
      }
    } catch (error) {
      console.error(
        `Error fetching wards for hospital (${hospitalId}): `,
        error
      );
    }
  };

  const fetchData = () => {
    const timeOut = setTimeout(() => {
      //setLoading(true);
      let formattedStartDate;
      let formattedEndDate;

      if (selectedReportType === "External") {
        formattedStartDate = fromDate.isValid()
          ? fromDate.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
          : "";

        formattedEndDate = toDate.isValid()
          ? toDate.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
          : "";
      } else {
        formattedStartDate = fromDate.isValid()
          ? fromDate.startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
          : "";

        formattedEndDate = toDate.isValid()
          ? toDate.endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
          : "";
      }

      // const formattedStartDate = fromDate.isValid()
      //   ? fromDate.startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
      //   : "";

      // const formattedEndDate = toDate.isValid()
      //   ? toDate.endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
      //   : "";

      const url =
        "/reports/" +
        selectedReportType +
        "/" +
        formattedStartDate +
        "/" +
        formattedEndDate +
        "/" +
        encodeURIComponent(JSON.stringify(selectedHospitals));

      apiGet(
        url,
        {
          headers: headers(),
        },
        history
      )
        .then((response) => {
          if (response.data.length > 0) {
            console.log("report response.data : ", response.data);
            setData(response.data);
            setDataFiltered(response.data);
          } else {
            setData(null);
            setDataFiltered(null);
          }

          setLoading(false);
        })
        .catch((error) => {
          setData(null);
          setDataFiltered(null);
          setLoading(false);
          showSnackBar("error", "Failure", "Failed to retrieve data.");
        });
    }, 200);
    return () => clearTimeout(timeOut);
  };

  const showSnackBar = (type, title, subtitle) => {
    const options = { variant: type };

    enqueueSnackbar(
      <div style={{ display: "inline-grid" }}>
        <Typography data-test={"snack-title"} variant="h6">
          {title}
        </Typography>
        <Typography data-test={"snack-text"} variant="subtitle1">
          {subtitle}
        </Typography>
      </div>,
      options
    );
  };

  const isNullOrEmpty = (value) => {
    if (value === null || value === undefined) {
      return true;
    }

    if (typeof value === "string" && value.trim().toLowerCase() === "null") {
      return true;
    }

    if (Array.isArray(value) && value.length === 0) {
      return true;
    }

    if (typeof value === "string" && value.trim() === "") {
      return true;
    }

    if (typeof value === "number" && isNaN(value)) {
      return true;
    }

    return false;
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handleFromDateChange = (date) => {
    //if (date && toDate && date > toDate) {
    //  setFromDate(null);
    //  showSnackBar("error", "Failure", "From date can't be after to date.");
    // } else {
    setFromDate(date);
    //}
  };

  const handleToDateChange = (date) => {
    //if (fromDate && date && fromDate > date) {
    // setToDate(null);
    // showSnackBar("error", "Failure", "To date can't be before from date.");
    //} else {
    setToDate(date);
    //}
  };

  const handleDateChange = (date) => {
    console.log("handleDateChange date :", date);
    console.log("handleDateChange start :", moment(date).startOf("day"));
    console.log("handleDateChange end :", moment(date).endOf("day"));

    setDate(date);
    setFromDate(moment(date).startOf("day"));
    setToDate(moment(date).endOf("day"));
  };

  const handleHospitalChange = (event) => {
    setSelectedHospitals(event.target.value);
  };

  const handleRoleChange = (event) => {
    setSelectedRoles(event.target.value);
  };

  const handleHospitalOfOriginChange = (event) => {
    setSelectedHospitalsOfOrigins(event.target.value);
  };

  const handleWardChange = (event) => {
    setSelectedWards(event.target.value);
  };

  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: 15,
        minHeight: "100vh",
        paddingTop: 40,
      }}
    >
      {loading ? (
        <CircularProgress color="primary" />
      ) : (
        <>
          <Grid
            container
            spacing={2}
            style={{ display: "flex", alignItems: "center" }}
          >
            <Grid
              item
              xs={12}
              md={12}
              style={{
                display: "flex",
              }}
            >
              <Grid
                container
                spacing={1}
                style={{ display: "flex", alignItems: "center" }}
              >
                <Grid item xs={6} md={2} style={{}}>
                  <TextField
                    data-test={"reports-report-type"}
                    select
                    fullWidth
                    required
                    label="Report Type"
                    size="small"
                    value={selectedReportType}
                    onChange={(e) => {
                      {
                        console.log("SelectedReportType : ", e.target.value);
                        setSelectedReportType(e.target.value);
                        setData([]);
                        setDataFiltered([]);
                        setFromDate(null);
                        setToDate(null);
                        setDate(null);
                        setSelectedHospitals([]);

                        setSelectedHospitalsOfOrigins([]);
                        setDataWards([]);
                        setSelectedWards([]);

                        qType = null;
                        qHospitalID = null;
                        qWardID = null;
                      }
                    }}
                  >
                    <MenuItem key={"Charter"} value={"Charter"}>
                      Charter Only
                    </MenuItem>
                    <MenuItem key={"Daily"} value={"Daily"}>
                      Daily Report
                    </MenuItem>
                    <MenuItem key={"External"} value={"External"}>
                      Share with external Hospital
                    </MenuItem>
                    <MenuItem key={"Occupancy"} value={"Occupancy"}>
                      Occupancy Report
                    </MenuItem>
                  </TextField>
                </Grid>

                {selectedReportType !== "" && (
                  <>
                    {selectedReportType === "Daily" ? (
                      <Grid item xs={6} md={2} style={{}}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <DateTimePicker
                            label="Date and Time"
                            slotProps={{
                              textField: {
                                variant: "outlined",
                                size: "small",
                                fullWidth: true,
                                "data-test": "reports-date",
                              },
                            }}
                            inputFormat="DD/MM/YYYY HH:mm"
                            timeSteps={{ minutes: 1 }}
                            value={moment(date, "YYYY-MM-DD HH:mm:ss")}
                            onChange={(date) => {
                              console.log(
                                "Date and Time changed:",
                                moment(date, "YYYY-MM-DD HH:mm:ss")
                              );
                              handleDateChange(date);
                            }}
                            onAccept={(date) => {
                              console.log(
                                "Date and Time selected:",
                                moment(date).format("YYYY-MM-DD HH:mm:ss")
                              );
                              handleDateChange(date);
                            }}
                            data-test="dashboard-date-time-picker"
                          />

                          {/* <DatePicker
                            label="Date"
                            slotProps={{
                              textField: {
                                variant: "outlined",
                                size: "small",
                                fullWidth: true,
                                "data-test": "reports-date",
                              },
                            }}
                            format="DD/MM/YYYY"
                            dayOfWeekFormatter={(day) => `${day}`}
                            // minDate={moment("01/01/2017").toDate()}
                            // maxDate={moment("12/31/2040").toDate()}
                            value={
                              date === null || date === undefined ? null : date
                            }
                            onChange={handleDateChange}
                          /> */}
                        </LocalizationProvider>
                      </Grid>
                    ) : (
                      <>
                        <Grid item xs={6} md={2} style={{}}>
                          {selectedReportType === "External" ? (
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                              <DateTimePicker
                                label="From Date & Time"
                                slotProps={{
                                  textField: {
                                    variant: "outlined",
                                    size: "small",
                                    fullWidth: true,
                                    "data-test": "reports-from-date-time",
                                  },
                                }}
                                ampm={false}
                                format="DD/MM/YYYY HH:mm"
                                dayOfWeekFormatter={(day) => `${day}`}
                                timeSteps={{ minutes: 1 }}
                                // minDate={moment("01/01/2017").toDate()}
                                // maxDate={moment("12/31/2040").toDate()}
                                value={
                                  fromDate === null || fromDate === undefined
                                    ? null
                                    : fromDate
                                }
                                onChange={handleFromDateChange}
                              />
                            </LocalizationProvider>
                          ) : (
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                              <DatePicker
                                label="From Date"
                                slotProps={{
                                  textField: {
                                    variant: "outlined",
                                    size: "small",
                                    fullWidth: true,
                                    "data-test": "reports-from-date",
                                  },
                                }}
                                format="DD/MM/YYYY"
                                dayOfWeekFormatter={(day) => `${day}`}
                                // minDate={moment("01/01/2017").toDate()}
                                // maxDate={moment("12/31/2040").toDate()}
                                value={
                                  fromDate === null || fromDate === undefined
                                    ? null
                                    : fromDate
                                }
                                onChange={handleFromDateChange}
                              />
                            </LocalizationProvider>
                          )}
                        </Grid>

                        <Grid item xs={6} md={2} style={{}}>
                          {selectedReportType === "External" ? (
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                              <DateTimePicker
                                label="To Date & Time"
                                slotProps={{
                                  textField: {
                                    variant: "outlined",
                                    size: "small",
                                    fullWidth: true,
                                    "data-test": "reports-to-date",
                                  },
                                }}
                                ampm={false}
                                format="DD/MM/YYYY HH:mm"
                                dayOfWeekFormatter={(day) => `${day}`}
                                timeSteps={{ minutes: 1 }}
                                // minDate={moment("01/01/2017").toDate()}
                                // maxDate={moment("12/31/2040").toDate()}
                                maxDate={moment().endOf("day")}
                                value={
                                  toDate === null || toDate === undefined
                                    ? null
                                    : toDate
                                }
                                onChange={handleToDateChange}
                              />
                            </LocalizationProvider>
                          ) : (
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                              <DatePicker
                                label="To Date"
                                slotProps={{
                                  textField: {
                                    variant: "outlined",
                                    size: "small",
                                    fullWidth: true,
                                    "data-test": "reports-to-date",
                                  },
                                }}
                                format="DD/MM/YYYY"
                                dayOfWeekFormatter={(day) => `${day}`}
                                // minDate={moment("01/01/2017").toDate()}
                                // maxDate={moment("12/31/2040").toDate()}
                                maxDate={moment().endOf("day")}
                                value={
                                  toDate === null || toDate === undefined
                                    ? null
                                    : toDate
                                }
                                onChange={handleToDateChange}
                              />
                            </LocalizationProvider>
                          )}
                        </Grid>
                      </>
                    )}

                    <Grid item xs={12} md={3} style={{}}>
                      <TextField
                        data-test={"reports-hospitals-select"}
                        id="outlined-select-hospital"
                        size="small"
                        select
                        fullWidth
                        label="Hospitals"
                        value={selectedHospitals}
                        onChange={handleHospitalChange}
                        SelectProps={{
                          multiple: true,
                          margin: "dense",
                          padding: 0,
                          renderValue: (selected) => (
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                              }}
                            >
                              {selected.map((value) => (
                                <Chip
                                  key={value}
                                  label={
                                    dataHospitals.find(
                                      (hospital) => hospital.id === value
                                    ).name
                                  }
                                  style={{
                                    margin: 1,
                                  }}
                                />
                              ))}
                            </div>
                          ),
                        }}
                      >
                        {dataHospitals.map((hospital) => (
                          <MenuItem key={hospital.id} value={hospital.id}>
                            <Checkbox
                              checked={
                                selectedHospitals.indexOf(hospital.id) > -1
                              }
                            />
                            <ListItemText primary={hospital.name} />
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    {(selectedReportType === "External" ||
                      selectedReportType === "Occupancy") && (
                      <Grid item xs={12} md={2} style={{}}>
                        <TextField
                          data-test={"reports-hospitals-of-origin-select"}
                          id="outlined-select-hospital-of-origin"
                          size="small"
                          select
                          fullWidth
                          label="Hospitals Of Origin"
                          value={selectedHospitalsOfOrigins}
                          onChange={handleHospitalOfOriginChange}
                          SelectProps={{
                            multiple: true,
                            margin: "dense",
                            padding: 0,
                            renderValue: (selected) => (
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                }}
                              >
                                {selected.map((value) => (
                                  <Chip
                                    key={value}
                                    label={
                                      dataHospitalsOfOrigins.length > 0
                                        ? dataHospitalsOfOrigins.find(
                                            (hospital) =>
                                              hospital.hospital_of_origin_id ===
                                              value
                                          ).name
                                        : ""
                                    }
                                    style={{
                                      margin: 1,
                                    }}
                                  />
                                ))}
                              </div>
                            ),
                          }}
                        >
                          {dataHospitalsOfOrigins.map((hospital) => (
                            <MenuItem
                              key={hospital.hospital_of_origin_id}
                              value={hospital.hospital_of_origin_id}
                            >
                              <Checkbox
                                checked={
                                  selectedHospitalsOfOrigins.indexOf(
                                    hospital.hospital_of_origin_id
                                  ) > -1
                                }
                              />
                              <ListItemText primary={hospital.name} />
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                    )}

                    {selectedReportType === "Daily" &&
                      !isNullOrEmpty(qWardID) && (
                        <Grid item xs={12} md={2} style={{}}>
                          <TextField
                            data-test={"reports-wards-select"}
                            id="outlined-select-wards"
                            size="small"
                            select
                            fullWidth
                            label={"Wards"}
                            value={selectedWards}
                            onChange={handleWardChange}
                            SelectProps={{
                              multiple: true,
                              margin: "dense",
                              padding: 0,
                              renderValue: (selected) => (
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                  }}
                                >
                                  {selected.map((value) => {
                                    const foundWard = dataWards.find(
                                      (ward) => ward.facility_id === value
                                    );

                                    if (foundWard) {
                                      const { facility, hospital_name } =
                                        foundWard;

                                      //const label = `${facility} (${hospital_name})`;
                                      const label = `${facility}`;

                                      return (
                                        <Chip
                                          key={value}
                                          label={label}
                                          style={{
                                            margin: 1,
                                          }}
                                        />
                                      );
                                    } else {
                                      return null; // or provide a default Chip or placeholder
                                    }
                                  })}
                                </div>
                              ),
                            }}
                          >
                            {dataWards.map((ward) => (
                              <MenuItem
                                key={ward.facility_id}
                                value={ward.facility_id}
                              >
                                <Checkbox
                                  checked={
                                    selectedWards.indexOf(ward.facility_id) > -1
                                  }
                                />
                                <ListItemText
                                  primary={
                                    !isNullOrEmpty(ward.facility)
                                      ? ward.facility
                                      : ""
                                  }
                                />
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                      )}

                    {selectedReportType === "Daily" &&
                      isNullOrEmpty(qWardID) && (
                        <Grid item xs={12} md={2} style={{}}>
                          <TextField
                            data-test={"reports-hospitals-of-origin-select"}
                            id="outlined-select-hospital-of-origin"
                            size="small"
                            select
                            fullWidth
                            label="Hospitals Of Origin"
                            value={selectedHospitalsOfOrigins}
                            onChange={handleHospitalOfOriginChange}
                            SelectProps={{
                              multiple: true,
                              margin: "dense",
                              padding: 0,
                              renderValue: (selected) => (
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                  }}
                                >
                                  {selected.map((value) => (
                                    <Chip
                                      key={value}
                                      label={
                                        dataHospitalsOfOrigins.length > 0
                                          ? dataHospitalsOfOrigins.find(
                                              (hospital) =>
                                                hospital.hospital_of_origin_id ===
                                                value
                                            ).name
                                          : ""
                                      }
                                      style={{
                                        margin: 1,
                                      }}
                                    />
                                  ))}
                                </div>
                              ),
                            }}
                          >
                            {dataHospitalsOfOrigins.map((hospital) => (
                              <MenuItem
                                key={hospital.hospital_of_origin_id}
                                value={hospital.hospital_of_origin_id}
                              >
                                <Checkbox
                                  checked={
                                    selectedHospitalsOfOrigins.indexOf(
                                      hospital.hospital_of_origin_id
                                    ) > -1
                                  }
                                />
                                <ListItemText primary={hospital.name} />
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                      )}

                    <Grid item xs={12} md={4} style={{}}>
                      <Button
                        data-test={"reports-generate-btn"}
                        variant="contained"
                        color="primary"
                        style={{ marginRight: 10 }}
                        disabled={
                          fromDate === null ||
                          toDate === null ||
                          selectedHospitals.length === 0
                        }
                        onClick={() => {
                          if (fromDate && toDate && fromDate > toDate) {
                            showSnackBar(
                              "error",
                              "Failure",
                              "To date can't be before from date."
                            );
                          } else if (fromDate && toDate && fromDate > toDate) {
                            showSnackBar(
                              "error",
                              "Failure",
                              "From date can't be after to date."
                            );
                          } else {
                            if (
                              selectedReportType === "Daily" &&
                              data.length > 0
                            ) {
                              resetDailyReportFilters();
                            }
                            fetchData();
                          }
                        }}
                      >
                        Generate
                      </Button>

                      {data !== null &&
                        data.length > 0 &&
                        loading === false && (
                          <>
                            <Button
                              data-test={"reports-print-btn"}
                              variant="contained"
                              color="primary"
                              //startIcon={<PrintIcon />}
                              style={{ marginRight: 10 }}
                              disabled={
                                selectedHospitals.length === 0 &&
                                data.length === 0
                              }
                              onClick={() => {
                                handlePrint();
                              }}
                            >
                              Print
                            </Button>

                            <ExportCSVButton
                              selectedHospitals={selectedHospitals}
                              data={data}
                            />

                            {/* {selectedReportType === "Occupancy" && (
                              <ExportCSVButton
                                selectedHospitals={selectedHospitals}
                                data={data}
                              />
                            )} */}
                          </>
                        )}
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>

            <Grid item xs={12} md={12} style={{}}>
              <Divider />
            </Grid>

            {selectedReportType === "Daily" &&
              data !== null &&
              data.length > 0 && (
                <Grid item xs={12} md={12} style={{}}>
                  <Grid container spacing={1}>
                    <Grid item xs={6} md={1}>
                      <FormControlLabel
                        data-test={"reports-daily-news-checkbox-title"}
                        control={
                          <Checkbox
                            data-test={"reports-daily-news-checkbox"}
                            checked={isNEWSSelected}
                            onChange={(e) =>
                              setIsNEWSSelected(e.target.checked)
                            }
                            name="news"
                            color="primary"
                          />
                        }
                        label={<span style={{ fontSize: "15px" }}>NEWS</span>}
                      />
                    </Grid>
                    <Grid item xs={6} md={1}>
                      <FormControlLabel
                        data-test={"reports-daily-waterlow-checkbox-title"}
                        control={
                          <Checkbox
                            data-test={"reports-daily-waterlow-checkbox"}
                            checked={isWaterlowSelected}
                            onChange={(e) =>
                              setIsWaterlowSelected(e.target.checked)
                            }
                            name="waterlow"
                            color="primary"
                          />
                        }
                        label={
                          <span style={{ fontSize: "15px" }}>Waterlow</span>
                        }
                      />
                    </Grid>
                    <Grid item xs={6} md={1}>
                      <FormControlLabel
                        data-test={"reports-daily-mmse-checkbox-title"}
                        control={
                          <Checkbox
                            data-test={"reports-daily-mmse-checkbox"}
                            checked={isMMSESelected}
                            onChange={(e) =>
                              setIsMMSESelected(e.target.checked)
                            }
                            name="mmse"
                            color="primary"
                          />
                        }
                        label={<span style={{ fontSize: "15px" }}>MMSE</span>}
                      />
                    </Grid>
                    <Grid item xs={6} md={1}>
                      <FormControlLabel
                        data-test={"reports-daily-frailty-checkbox-title"}
                        control={
                          <Checkbox
                            data-test={"reports-daily-frailty-checkbox"}
                            checked={isFrailtySelected}
                            onChange={(e) =>
                              setIsFrailtySelected(e.target.checked)
                            }
                            name="frailty"
                            color="primary"
                          />
                        }
                        label={
                          <span style={{ fontSize: "15px" }}>Frailty</span>
                        }
                      />
                    </Grid>
                    <Grid item xs={6} md={1}>
                      <FormControlLabel
                        data-test={"reports-daily-barthel-checkbox-title"}
                        control={
                          <Checkbox
                            data-test={"reports-daily-barthel-checkbox"}
                            checked={isBarthelSelected}
                            onChange={(e) =>
                              setIsBarthelSelected(e.target.checked)
                            }
                            name="barthel"
                            color="primary"
                          />
                        }
                        label={
                          <span style={{ fontSize: "15px" }}>Barthel</span>
                        }
                      />
                    </Grid>
                    <Grid item xs={6} md={1}>
                      <FormControlLabel
                        data-test={"reports-daily-must-checkbox-title"}
                        control={
                          <Checkbox
                            data-test={"reports-daily-must-checkbox"}
                            checked={isMUSTSelected}
                            onChange={(e) =>
                              setIsMUSTSelected(e.target.checked)
                            }
                            name="must"
                            color="primary"
                          />
                        }
                        label={<span style={{ fontSize: "15px" }}>MUST</span>}
                      />
                    </Grid>
                    <Grid item xs={6} md={1}>
                      <FormControlLabel
                        data-test={"reports-daily-notes-checkbox-title"}
                        control={
                          <Checkbox
                            data-test={"reports-daily-notes-checkbox"}
                            checked={isNotesSelected}
                            onChange={(e) =>
                              setIsNotesSelected(e.target.checked)
                            }
                            name="notes"
                            color="primary"
                          />
                        }
                        label={<span style={{ fontSize: "15px" }}>Notes</span>}
                      />
                    </Grid>
                    <Grid item xs={6} md={1}>
                      <FormControlLabel
                        data-test={"reports-daily-plans-checkbox-title"}
                        control={
                          <Checkbox
                            data-test={"reports-daily-plans-checkbox"}
                            checked={isPlansSelected}
                            onChange={(e) =>
                              setIsPlansSelected(e.target.checked)
                            }
                            name="plans"
                            color="primary"
                          />
                        }
                        label={<span style={{ fontSize: "15px" }}>Plans</span>}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        data-test={"reports-roles-select"}
                        id="outlined-select-roles"
                        size="small"
                        select
                        fullWidth
                        label="Roles"
                        value={selectedRoles}
                        onChange={handleRoleChange}
                        SelectProps={{
                          multiple: true,
                          margin: "dense",
                          padding: 0,
                          renderValue: (selected) => (
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                              }}
                            >
                              {selected.map((value) => {
                                const role = dataRoles.find(
                                  (role) => role.level_id === value
                                );
                                const labelBeforeParentheses =
                                  role.level_description
                                    .substring(
                                      0,
                                      role.level_description.indexOf("(")
                                    )
                                    .trim();
                                return (
                                  <Chip
                                    key={value}
                                    label={labelBeforeParentheses}
                                    style={{
                                      margin: 1,
                                    }}
                                  />
                                );
                              })}
                            </div>
                          ),
                        }}
                      >
                        {dataRoles.map((role) => (
                          <MenuItem key={role.level_id} value={role.level_id}>
                            <Checkbox
                              checked={
                                selectedRoles.indexOf(role.level_id) > -1
                              }
                            />
                            <ListItemText
                              primary={role.level_description
                                .substring(
                                  0,
                                  role.level_description.indexOf("(")
                                )
                                .trim()}
                            />
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
              )}
          </Grid>
          <Box style={{ margin: 50 }} ref={componentRef}>
            <Grid
              container
              spacing={1}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {data !== null && data.length > 0 ? (
                <>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        paddingBottom: 20,
                      }}
                    >
                      <img src={Logo} alt="Logo" style={{ height: 55 }} />
                    </div>
                    <Typography
                      data-test={"report-list-title"}
                      variant="h5"
                      style={{ textAlign: "center", fontWeight: "bold" }}
                    >
                      {selectedReportType === "Charter"
                        ? "Charter internal report"
                        : selectedReportType === "External"
                        ? "Share with external hospital report"
                        : selectedReportType === "Daily"
                        ? "Daily Report"
                        : selectedReportType === "Occupancy"
                        ? "Occupancy Report"
                        : null}
                    </Typography>

                    {selectedReportType === "Daily" ? (
                      <>
                        <Typography
                          data-test={"report-list-subtitle"}
                          variant="caption"
                          style={{ textAlign: "center" }}
                        >
                          {"Report Date: " + moment(date).format("DD/MM/yyyy")}
                        </Typography>

                        <Typography
                          variant="caption"
                          style={{ textAlign: "left", textAlign: "center" }}
                        >
                          {moment().format("DD/MM/yyyy HH:mm:ss")}
                        </Typography>
                      </>
                    ) : (
                      <>
                        <Typography
                          variant="caption"
                          style={{ textAlign: "center" }}
                        >
                          {"Report Date Range: " +
                            moment(fromDate).format("DD/MM/yyyy") +
                            " - " +
                            moment(toDate).format("DD/MM/yyyy")}
                        </Typography>

                        <Typography
                          variant="caption"
                          style={{ textAlign: "left", textAlign: "center" }}
                        >
                          {moment().format("DD/MM/yyyy HH:mm:ss")}
                        </Typography>
                      </>
                    )}
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={12}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      padding: 15,
                    }}
                  >
                    {selectedReportType === "Charter" ? (
                      <CharterReport
                        data={data}
                        dataHospitals={dataHospitals}
                        fromDate={fromDate}
                        toDate={toDate}
                      />
                    ) : selectedReportType === "External" ? (
                      <ExternalReport
                        data={data}
                        dataHospitals={dataHospitals}
                        selectedHospitals={selectedHospitals}
                        selectedHospitalsOfOrigins={selectedHospitalsOfOrigins}
                        fromDate={fromDate}
                        toDate={toDate}
                      />
                    ) : selectedReportType === "Occupancy" ? (
                      <OccupancyReport
                        data={data}
                        dataHospitals={dataHospitals}
                        selectedHospitals={selectedHospitals}
                        selectedHospitalsOfOrigins={selectedHospitalsOfOrigins}
                        fromDate={fromDate}
                        toDate={toDate}
                      />
                    ) : selectedReportType === "Daily" ? (
                      <DailyReport
                        data={dataFiltered}
                        dataHospitals={dataHospitals}
                        selectedHospitals={selectedHospitals}
                        selectedHospitalsOfOrigins={selectedHospitalsOfOrigins}
                        selectedWards={selectedWards}
                        fromDate={fromDate}
                        toDate={toDate}
                        isNEWSSelected={isNEWSSelected}
                        isWaterlowSelected={isWaterlowSelected}
                        isMMSESelected={isMMSESelected}
                        isFrailtySelected={isFrailtySelected}
                        isBarthelSelected={isBarthelSelected}
                        isMUSTSelected={isMUSTSelected}
                        isNotesSelected={isNotesSelected}
                        isPlansSelected={isPlansSelected}
                      />
                    ) : null}
                  </Grid>
                </>
              ) : (
                data === null && (
                  <Typography
                    data-test={"reports-empty-msg"}
                    style={{ textAlign: "center" }}
                  >
                    There is no data available for the selected ranges.
                  </Typography>
                )
              )}
            </Grid>
          </Box>
        </>
      )}
    </div>
  );
}
